<template>
  <nav
    class="fixed top-0 left-0 w-full z-50 bg-[#222222] shadow border-gray-200"
    :class="[theme ? 'dark:bg-gray-800 dark:border-gray-700' : '']"
  >
    <div
      class="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4"
    >
      <a href="#" class="flex items-center space-x-3 rtl:space-x-reverse">
        <img
          :src="appLogo"
          class="h-8"
          alt="CombateOne"
        />
      </a>

      <button
        data-collapse-toggle="navbar-solid-bg"
        type="button"
        class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
        :class="[
          theme
            ? 'dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600'
            : '',
        ]"
        aria-controls="navbar-solid-bg"
        aria-expanded="false"
      >
        <span class="sr-only">Open main menu</span>
        <svg
          class="w-5 h-5"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 17 14"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M1 1h15M1 7h15M1 13h15"
          />
        </svg>
      </button>

      <div class="hidden w-full md:block md:w-auto" id="navbar-solid-bg">
        <ul
          class="font-berthold-force tracking-wider text-white flex flbex-col font-medium mt-4 rounded-lg md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 md:bg-transparent uppercase"
          :class="[
          ]"
        >
          <li>
            <a
              @click.prevent="scrollToSection('ppv')"
              class="block py-2 px-3 text-white rounded-sm hover:text-[#d20a0a] font-semibold cursor-pointer mt-auto mb-auto mx-4 md:mx-0"
              :class="[
                activeMenu == 'inicio'
                  ? 'text-[#d20a0a] font-bold hover:text-white'
                  : '',
              ]"
              aria-current="page"
            >
              PPV
            </a>
          </li>

          <li>
            <router-link
              to="/auth"
              class="block py-2 px-6 text-white rounded-sm hover:text-white transition-all hover:bg-red-800 font-semibold cursor-pointer bg-[#d20a0a] mt-auto mb-auto mx-4 md:mx-0"
              :class="[
                activeMenu == 'lutas'
                  ? 'font-bold hover:text-white'
                  : '',
              ]"
            >
              entrar
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { dataShared } from '../store'
import { computed } from 'vue'
import defaultLogo from '@/assets/logo/logo-rs.png'

const appLogo = computed(() => {
  return dataShared.getters.getLogo || defaultLogo
})

const theme = computed(() => dataShared.getters.getTheme)
const activeMenu = computed(() => dataShared.getters.getMenuActive)

function scrollToSection (id) {
  const el = document.getElementById(id)
  if (el) el.scrollIntoView({ behavior: 'smooth' })
}

</script>
